import { createBrowserRouter, Navigate } from 'react-router';

import { AuthGuard, GhostGuard, AuthCallback } from '@lib/auth';
import Sideblock from '@/ds/layouts/Sideblock';
import Dashboard from '../pages/dashboard';
import Sources from '../pages/sources';
import Personas from '../pages/personas';
import ContentPipeline from '../pages/content';
import Playground from '../pages/playground';
import WizardSelector from '../pages/poc/wizards';
import StepByStepWizardPage from '../pages/poc/wizards/StepByStepWizard/page';
import InterviewWizardPage from '../pages/poc/wizards/InterviewWizard/page';
import TemplateWizardPage from '../pages/poc/wizards/TemplateWizard/page';
import LivePreviewWizardPage from '../pages/poc/wizards/LivePreviewWizard/page';
import PersonaStudioLibrary from '../pages/persona-studio';
import PersonaStudioCreate from '../pages/persona-studio/create';
import PersonaStudioPlayground from '../pages/persona-studio/playground';
import SourceModelingSelector from '../pages/poc/source-modeling';
import SimpleWizard from '../pages/poc/source-modeling/SimpleWizard';
import FlexibleWizard from '../pages/poc/source-modeling/FlexibleWizard';
import PipelineWizard from '../pages/poc/source-modeling/PipelineWizard';
import ProgressiveWizard from '../pages/poc/source-modeling/ProgressiveWizard';
import IherbPostsPage from '../pages/iherb-posts';
import SettingsPage from '../pages/settings';
import ErrorBoundary from '../components/ErrorBoundary';

const router = createBrowserRouter([
  {
    id: 'root',
    children: [
      // Protected routes (require auth)
      {
        id: 'protected',
        Component: AuthGuard,
        children: [
          {
            path: '/',
            element: <Sideblock />,
            errorElement: <ErrorBoundary />,
            children: [
              { index: true, element: <Dashboard /> },
              { path: 'sources', element: <Sources /> },
              { path: 'personas', element: <Personas /> },
              { path: 'content', element: <ContentPipeline /> },
              { path: 'playground', element: <Playground /> },
              { path: 'poc/wizards', element: <WizardSelector /> },
              { path: 'poc/wizards/step-by-step', element: <StepByStepWizardPage /> },
              { path: 'poc/wizards/interview', element: <InterviewWizardPage /> },
              { path: 'poc/wizards/template', element: <TemplateWizardPage /> },
              { path: 'poc/wizards/live-preview', element: <LivePreviewWizardPage /> },
              { path: 'poc/source-modeling', element: <SourceModelingSelector /> },
              { path: 'poc/source-modeling/progressive', element: <ProgressiveWizard /> },
              { path: 'poc/source-modeling/simple', element: <SimpleWizard /> },
              { path: 'poc/source-modeling/flexible', element: <FlexibleWizard /> },
              { path: 'poc/source-modeling/pipeline', element: <PipelineWizard /> },
              { path: 'persona-studio', element: <PersonaStudioLibrary /> },
              { path: 'persona-studio/create', element: <PersonaStudioCreate /> },
              { path: 'persona-studio/:id/edit', element: <PersonaStudioCreate /> },
              { path: 'persona-studio/playground', element: <PersonaStudioPlayground /> },
              { path: 'iherb-posts', element: <IherbPostsPage /> },
              { path: 'settings', element: <SettingsPage /> },
            ],
          },
        ],
      },
      // Ghost routes (only for non-authenticated)
      {
        id: 'ghost',
        Component: GhostGuard,
        children: [{ path: '/callback', element: <AuthCallback /> }],
      },
      // Catch-all
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
]);

export default router;
